import FetchAPI from "../helpers/FetchAPI";
import { TypeMethodConstantEnum } from "../helpers/MethodAPIConstant";
class MailTemplateServices extends FetchAPI {
    public async getAll(data) {
        const url = `mail-template/getAll`;
        return await this.request(url, { data }, TypeMethodConstantEnum.GET);
    }
    public async getFilter(data) {
        const url = `mail-template/index`;
        return await this.request(url, data, TypeMethodConstantEnum.GET);
    }
    public async getById(data) {
        const url = `/mail-template/getById`;
        return await this.request(url, data, TypeMethodConstantEnum.GET);
    }
    public async create(data) {
        const url = `mail-template/create`;
        return await this.request(url, data, TypeMethodConstantEnum.POST);
    }
    public async update(data) {
        const url = `mail-template/update`;
        return await this.request(url, data, TypeMethodConstantEnum.POST);
    }
    public async delete(data) {
        const url = `mail-template/delete`;
        return await this.request(url, data, TypeMethodConstantEnum.GET);
    }
    public async deleteMultiple(data) {
        const url = `mail-template/deleteMultiple`;
        return await this.request(url, data, TypeMethodConstantEnum.POST);
    }
}
export default MailTemplateServices;
